<span [innerHtml]="svgElement" [style.color]="svgColor"></span>
